// WebHostingCheckoutFields.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useFormikContext, useField } from "formik";
import { Switch } from "@headlessui/react"; // Import the Headless UI switch
import { usePageSettings } from "../../../../../contexts/PageSettingsContext";
import TabTitle from "../TabTitle";
import FormikStyledField from "../../../inputs/form/FormikStyledField";

const fadeInUp = {
	initial: { opacity: 0, y: 20 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: 20 },
};

const WebHostingCheckoutFields = () => {
	const { translations } = usePageSettings();

	// We grab the Formik field for configuration.hasDomain:
	const [field, , helpers] = useField("configuration.hasDomain");
	const { value: hasDomain } = field;
	const { setValue } = helpers;

	// A toggle handler that flips from true to false (or vice versa):
	const handleToggleDomain = () => {
		setValue(!hasDomain);
	};

	return (
		<AnimatePresence>
			<TabTitle
				title="Configurar hosting"
				subtitle="Escribe tu dominio, si aún no tienes, se configurará una vez confirmada la orden."
			/>

			<motion.div
				key="webHostingCheckoutFields"
				className="grid grid-cols-1 gap-4 py-7 gap-x-12 gap-y-7"
				variants={fadeInUp}
				initial="initial"
				animate="animate"
				exit="exit"
			>
				<div className="flex items-center gap-2">
					<p>{translations["WebhostingSwichLabel"]}</p>
					<Switch
						checked={hasDomain}
						onChange={handleToggleDomain}
						className={`
              relative inline-flex items-center
              h-4 w-[29px] cursor-pointer rounded-full p-[1px]
              transition-colors duration-200 ease-in-out
              ${hasDomain ? "bg-ipxon-magenta" : "bg-white border border-zinc-200"}
            `}
					>
						<span
							aria-hidden="true"
							className={`
                inline-block h-[13px] w-[13px] transform rounded-full bg-gray-400
                transition duration-200 ease-in-out
                ${hasDomain ? "translate-x-[14px] !bg-white" : "translate-x-0"}
              `}
						/>
					</Switch>
				</div>

				{/* Conditionally render the domain field if hasDomain is true */}
				{hasDomain && <FormikStyledField label="Hostname" name="configuration.serverName" type="text" />}
			</motion.div>
		</AnimatePresence>
	);
};

export default WebHostingCheckoutFields;
